import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, HostListener, ViewChild } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { Subscription } from 'rxjs';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { VennHealthDataService } from '@app/services/vennhealth-data.service';
import { VennHealthDialogService } from '@app/services/vennhealth-dialog.service';

@Component({
  selector: 'app-common-inputs',
  templateUrl: './common-inputs.component.html',
  styleUrls: ['./common-inputs.component.css']
})
export class CommonInputsComponent implements OnInit, OnDestroy {

  @ViewChild("editQueryNameTextBox") private editQueryNameTextBox: TextBoxComponent;

  @Input() opened: boolean;
  queryName = '';
  queryNameChange = '';
  showSelectionsSection = false;
  editQueryName: boolean = false;
  queryId = 0;
  savedFilterNamesList = [];

  queryNameSubscription: Subscription;
  
  screenHeight: number;
  screenWidth: number;
  
  constructor(
    private readonly sharedService: SharedService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly vennHealthDataService: VennHealthDataService,
    private readonly vennHealthDialogService: VennHealthDialogService
  ) {
    this.getScreenSize();
   }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    this.sharedService.setFiltersPanelSubscription(this.showSelectedFiltersPanel());
    // console.log(this.screenHeight, this.screenWidth);
  }

  ngOnInit(): void {
    // common inputs subscription
    this.queryNameSubscription = this.sharedService.activeQueryName.subscribe(
      data => {
        if (data !== null) {
          this.queryName = data;
          this.cdRef.detectChanges();
          // we're going to safely assume that if the saved name changed then that query was loaded or saved
          // so that's when we will set the current selected saved filters to use for comparing against
          //TODO look into this this.currentSavedQueryFilters = this.allSelectedIncidenceFilters;
        }
      }
    );

    this.vennHealthDataService.getClientSavedFilterNamesList().subscribe(
      data => {
        if (data !== null) {
          this.savedFilterNamesList = data;
        }
      }
    );

    this.sharedService.activeQueryId.subscribe(
      data => {
        if (data !== null) {
          this.queryId = data;
        }
      }
    );
  }

  showSelectedFiltersPanel(): boolean {
    if (this.screenWidth >= 992) {
      return true;
    }
    return false;
  }

  toggleQueryNameEdit(): void {
    this.editQueryName = !this.editQueryName;
    if (this.editQueryName && this.editQueryNameTextBox) {
      setTimeout(() => {
        this.editQueryNameTextBox.focus();
      }, 10);
    }
  }

  onEditQueryNameBlur(): void {
    this.editQueryName = false;
    this.renameQuery();
  }

  onQueryNameChange(value: string): void {
    this.queryNameChange = value;
  }

  renameQuery() {
    var apiData = {
      queryId: this.queryId,
      queryName: this.queryNameChange
    };
    this.vennHealthDataService.renameFilter(apiData).subscribe({
      next: (response) => {
        if (response !== null) {
          if (response.hasErrors === false) {
            this.sharedService.setActiveQueryName(this.queryNameChange);
            this.sharedService.setRefreshSavedQueries();
            this.queryNameChange = '';
          } else if (response.hasErrors) {
            this.vennHealthDialogService.showNotification("Failed to rename query", {style: 'error', icon: true });
          }
        }
      },
      error: (e) => { 
        this.vennHealthDialogService.showNotification("Failed to rename query", {style: 'error', icon: true });
      },
      complete: () => {
      }
    });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.queryNameSubscription.unsubscribe();
  }
}
